import React, { useState, Fragment, useContext, useRef } from "react";
import { useHistory } from "react-router-dom";

import navigationMenuItems from "./NavigationMenuItems";
import styles from "./styles";
import logo from "../../assets/logo.jpg";


import propTypes from "prop-types";
import { SearchContext } from "../../pages/dash/components/search/searchBooking";
import { SessionContext } from "../../utility/useSession";

import usePaths from "../../utility/paths";

const NavigationMenu: React.FunctionComponent<{
    showNav: boolean,
    isLargeDevice: boolean,
    setShowNav: (value: boolean) => void,
}> = (props) => {

    const paths = usePaths();

    const history = useHistory();

    const [showTooltip, setShowToolTip] = useState("");

    // const logoutUser = useDispatch(authenticationReducers.logout);
    const pathname = document.location.pathname;

    const searchContext = useContext(SearchContext);

    const session = useContext(SessionContext);

    const navigate = async (url?: string) => {

        if (!url) {
            return;
        }

        if (searchContext.setCriteria) {
            if (searchContext.criteria) {
                searchContext.setCriteria({
                    ...searchContext.criteria, show: false, search: ""
                })
            }
        }

        if (url == paths.logout) {
            history.push("/");
            // await logoutUser();
            session.logout();

        } else if (url == paths.search) {
            if (searchContext.criteria) {
                if (searchContext.setCriteria) {
                    props.setShowNav(!searchContext.criteria.show == false);
                    searchContext.setCriteria({ ...searchContext.criteria, show: true });
                }
            }

        } else if (url == paths.close) {

            if (searchContext.criteria) {
                if (searchContext.setCriteria) {
                    props.setShowNav(false);
                    searchContext.setCriteria({ ...searchContext.criteria, show: false });
                }
            }

        } else {
            history.push(url);
        }
    }

    const navContainerRef = useRef<HTMLDivElement>(null);
    const [scrollTop, setScrollTop] = useState(0);

    const onHover = (name: string) => {
        if (navContainerRef.current) {
            const rect = navContainerRef.current.getBoundingClientRect();
            setScrollTop(rect.y);
        }
        setShowToolTip(name)
    }

    return (
        <div ref={navContainerRef} style={styles.container}>
            <div style={styles.menuItemsTopContainer}>
                <div style={styles.homeIconContainer}>
                    <img onClick={() => {
                        navigate(paths.home);
                    }} src={logo} style={styles.homeIcon} />
                </div>
            </div>
            <div style={styles.menuItemsContainer}>

                <div style={styles.menuItemsContainerInner}>
                    {navigationMenuItems().map((menuItem) => {
                        if (props.isLargeDevice == true) {
                            if (menuItem.link == paths.close || menuItem.link == paths.search) {
                                return (<Fragment key={menuItem.name}></Fragment>)
                            }
                        }
                        return (
                            <div
                                role="presentation"
                                key={menuItem.name}
                                style={pathname === menuItem.link ? { ...styles.menuItem, ...styles.menuItemSelected } : styles.menuItem}
                                onMouseEnter={() => onHover(menuItem.name)}
                                onMouseLeave={() => setShowToolTip('')}
                                onClick={() => navigate(menuItem.link)}
                                data-testid={`MenuItem-${menuItem.name.replace(/\s/g, '-')}`}
                                data-google-id={`MenuItem-${menuItem.name.replace(/\s/g, '-')}`}
                            >
                                {menuItem.icon}
                                {showTooltip === menuItem.name && (<div style={{ ...styles.tooltip, marginTop: scrollTop - 47 }}>
                                    {menuItem.formatMessage}
                                </div>)}
                            </div>
                        );
                    })}

                </div>
            </div>
        </div>
    );
}

NavigationMenu.propTypes = {
    setShowNav: propTypes.func.isRequired,
    showNav: propTypes.bool.isRequired,
    isLargeDevice: propTypes.bool.isRequired
}

export default NavigationMenu;